"use client";

import { CheckCircle, Circle, Clock } from "lucide-react";
import { useTranslations } from "next-intl";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { FeedbackStatusEnum } from "@/types/feedback";

interface FeedbackStatusBadgeProps {
  status: FeedbackStatusEnum;
  className?: string;
}

const STATUS_CONFIG: Record<
  FeedbackStatusEnum,
  { bg: string; text: string; icon: React.ReactNode }
> = {
  [FeedbackStatusEnum.SUBMITTED]: {
    bg: "bg-bg-tertiary/60",
    text: "text-text-secondary",
    icon: <Circle className="size-3" />,
  },
  [FeedbackStatusEnum.UNDER_REVIEW]: {
    bg: "bg-semantic-link/15",
    text: "text-semantic-link",
    icon: <Clock className="size-3" />,
  },
  [FeedbackStatusEnum.ADDRESSED]: {
    bg: "bg-semantic-success/15",
    text: "text-semantic-success",
    icon: <CheckCircle className="size-3" />,
  },
};

export const FeedbackStatusBadge: React.FC<FeedbackStatusBadgeProps> = ({
  status,
  className,
}) => {
  const t = useTranslations("feedback");
  const config = STATUS_CONFIG[status];

  return (
    <Badge
      variant="outline"
      size="sm"
      className={cn(
        "rounded-xs border-transparent gap-1",
        config.bg,
        config.text,
        className,
      )}
    >
      {config.icon}
      {t(`status.${status}`)}
    </Badge>
  );
};
